export default "__VITE_ASSET__5bd8f957__"